import { useTranslation } from "react-i18next";
import { possibleIpStates, useFilter } from "./Filter";
import clsx from "clsx";
import { useEffect, useRef } from "react";
import { BrandStatus } from "src/trademarks/TrademarksProvider";
import { FamilyMemberStatus } from "src/patents/patents";
import { CommodityStatus } from "src/products/products";
import { DesignRegistrationStatus } from "src/designs/designs";
import _ from "lodash";

export function translateforTrademarks(state: string): BrandStatus {
  switch(state) {
    case 'in-preparation': return 'planned'
    case 'pending': return 'applied'
    case 'granted': return 'registered'
    case 'stopped': return 'stopped'
  }
}


//export type CommodityStatus = 'active' | 'stopped' | 'planned';
export function translateForProducts(state: FamilyMemberStatus): CommodityStatus {
  switch(state) {
    case 'in-preparation': return 'planned'
    case 'pending': return 'planned'
    case 'granted': return 'active'
    case 'stopped': return 'stopped'
  }
}

export function translateForDesigns(state: FamilyMemberStatus): DesignRegistrationStatus[] {
  switch(state) {
    case 'in-preparation': return ['in-preparation']
    case 'pending': return ['pending']
    case 'granted': return ['registered']
    case 'stopped': return ['stopped']
  }
}

export function IpStatusRibbon() {
  const {t} = useTranslation()

  const {ipStates, showActiveOnly, setShowActiveOnly} = useFilter()

  if (showActiveOnly === undefined) {
    return <div className="bg-pcx-500 text-white text-sm px-1 rounded-sm">{ipStates.map(s => t(s)).join(', ')}</div>
  } else {
    return (
      <label
        className={clsx(
          'flex items-center gap-1 pl-2 pr-1 text-sm rounded-sm ',
          showActiveOnly ? 'bg-pcx-500 hover:bg-pcx-400 text-white' : 'bg-pcx-400 text-pcx-200 hover:text-white',
        )}
      >
        <span className="text-sm max-w-[10rem] whitespace-nowrap overflow-hidden text-ellipsis">{t('active-only')}</span>
        <input
          type="checkbox"
          className="ml-1 form-checkbox bg-pcx-200 focus:ring-0 focus:outline-none focus:outline-0 focus-visible:ring-0 focus-visible:outline-none focus-visible:outline-0"
          checked={showActiveOnly}
          onChange={e => setShowActiveOnly(e.target.checked)}
        />
      </label>
    )
  }
}

export function IpStatusSetting() {
  const {t} = useTranslation()

  const ref = useRef(null)
  const {ipStates, setIpStates, showActiveOnly: activeOnly, setShowActiveOnly} = useFilter()

  useEffect(() => {
    if (ref?.current) {
      ref.current.indeterminate = activeOnly === undefined
    }
  }, [ref, activeOnly])

  function handleChange(state: FamilyMemberStatus) {
    return (checked: boolean) => {
      if (!checked) {
        setIpStates(ipStates.filter(s => s !== state))
      } else {
        if (!ipStates.includes(state)) {
          setIpStates([...ipStates, state])
        } // else should not happen; NO-OP
      }
    }
  }

  const isLastRemainingState = (state: FamilyMemberStatus) => ipStates.length === 1 && ipStates[0] === state

  function makeTitle(state: FamilyMemberStatus) {
    const allStates = _([
      translateforTrademarks(state),
      translateForProducts(state),
      ...translateForDesigns(state),
    ]).uniq().map(t).sortBy().join(', ')
    return allStates
  }

  return (
    <div>
      <div className="block font-medium mb-2">{t('status')}</div>
      <div className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-1 items-center">
        <input
          id="activeOnly" type="checkbox" className="form-checkbox" ref={ref}
          checked={activeOnly} onChange={e => setShowActiveOnly(e.target.checked)} />
        <label htmlFor="activeOnly" className="label">{t('activeOnly')}</label>

        <div className="h-0.5 col-span-2 bg-slate-300" />

        {possibleIpStates.map(state => <>
          <input 
            key={state} id={state} type="checkbox" className="form-checkbox disabled:bg-slate-400 disabled:hover:bg-slate-400"
            checked={ipStates.includes(state)} onChange={e => handleChange(state)(e.target.checked)}
            disabled={isLastRemainingState(state)} 
          />
          <label htmlFor={state} className="label" title={makeTitle(state)}>{t(state)}</label>
        </>)}
      </div>
    </div>
  )
}
